import { type SxProps, Tooltip, Typography } from "@mui/material";

export const HppdKeyTypography = ({ keyString, sxOverride }: { keyString: string; sxOverride?: SxProps }) => {
	return (
		<Tooltip title={keyString}>
			<Typography
				sx={{
					fontWeight: 600,
					color: "primary.main",
					maxWidth: "60px",
					textOverflow: "ellipsis",
					textWrap: "nowrap",
					overflow: "hidden",
					...sxOverride,
				}}
			>
				{keyString}
			</Typography>
		</Tooltip>
	);
};
